import { StateTransitionsTable } from "@/components/stock/state-transitions-table";
import { useSuborderStateTransitions } from "@/hooks/use-suborder-state-transitions";
import type { SuborderPanelBaseProps } from "../../shared";

/**
 * This round's protocol: raised, released to the floor, started, signed off.
 *
 * The order-level transitions are left out — every row here is about the same round, so the level
 * column is hidden, and the order's derived states belong beside the sibling rounds that explain
 * them.
 */
export function SuborderProtocol({ orderId, suborderId }: SuborderPanelBaseProps) {
	/** Query */
	const { stateTransitions, isLoading, refetch, queryKey } = useSuborderStateTransitions(
		orderId,
		suborderId,
	);

	/** Render */
	return (
		<StateTransitionsTable
			stateTransitions={stateTransitions}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			persistenceKey="suborder-protocol-table"
			withLevel={false}
		/>
	);
}
